import React, {useCallback, useState} from "react";
import { useTranslation } from "react-i18next";
import ImageViewer from 'react-simple-image-viewer';
import Slider from "react-slick";

export const Media = (props) => {
  const { t } = useTranslation();
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 2,
    dots: true,
    arrows: false,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          swipeToSlide: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <div id="media" className="text-center">
      <div className="container">
        <div className="row">
          <div className="section-title">
            <h2>{t('media.title')}</h2>
          </div>
          <div className="portfolio-items">
            <Slider {...settings}>
              {props.data && props.data.map((src, index) => (
                  <div key={index}>
                    <img src={src} onClick={() => openImageViewer(index)} alt={src}/>
                  </div>
              ))}
            </Slider>
            {isViewerOpen && (
                <ImageViewer
                    src={props.data}
                    currentIndex={currentImage}
                    disableScroll={true}
                    closeOnClickOutside={true}
                    onClose={closeImageViewer}
                />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
